import * as React from "react";
import { CaseStatus } from "@kahunmedical/common-wtypes";
import { useTranslateByGender } from "fe-common/locale/useTranslateByGender";
import { SkeletonLoader } from "../loader/skeletonLoader";
import { CommonPatientCardDd } from "./commonPatientCardDd";
import { SortType, SummaryDiseaseCluster } from "fe-common/graphql";
import { AlertMessage } from "./AlertMessage";
import ColumnHeader from "./ColumnHeader";
import { SummaryActionIcon } from "./summaryActionIcon";
import { copyToClipboard } from "fe-common/utils/copyToClipboard";
import { useRef } from "react";
import { AlertColor } from "@mui/material/Alert";

//region [[ Styles ]]

//endregion [[ Styles ]]

//region [[ Props ]]

export interface PatientDdProps {
  loading: boolean;
  dd: SummaryDiseaseCluster[];
  status: CaseStatus;
  inExtension?: boolean;
  simpleView?: boolean;
  showRagDisclaimer?: boolean;
  onShowMessage?: (
    text: string | React.ReactNode,
    severity: AlertColor,
  ) => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const PatientDd = ({
  loading,
  dd,
  status,
  simpleView,
  onShowMessage,
  inExtension,
  showRagDisclaimer,
}: PatientDdProps) => {
  const { translate } = useTranslateByGender();
  const textElementRef = useRef(null);
  const title = translate("POSSIBLE_CAUSES");
  return (
    <div className="column-section dd-column">
      {
        <ColumnHeader
          title={simpleView ? "" : title}
          buttons={
            !loading && (
              <SummaryActionIcon
                noBackground
                onClick={() => {
                  copyToClipboard(textElementRef.current);
                  onShowMessage &&
                    onShowMessage(
                      `${title || ""} ${translate("COPIED")}`,
                      null,
                    );
                }}
                inExtension={inExtension}
              />
            )
          }
        />
      }
      <div className="column-content" ref={textElementRef}>
        {loading ? (
          <SkeletonLoader />
        ) : (
          <>
            {status === CaseStatus.ABANDONED && (
              <AlertMessage message={translate("PARTIAL_DD")} />
            )}
            <CommonPatientCardDd
              sortType={SortType.PatientProb}
              dd={dd}
              hideFirstSubHeader={true}
              scrollable={false}
              inExtension={false}
              simpleView={simpleView}
            />
            {showRagDisclaimer && (
              <AlertMessage
                message={
                  "This section is currently under development and may not display complete or accurate information."
                }
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};
